<template>
  <div class="r-order-filter">
    <Modal
      :draggable="false"
      footer-hide
      :mask-closable="false"
      :styles="{ top: 0, width: '100%' }"
      v-model="show"
    >
      <div class="title-box">
        <div class="title">{{ $t("order.filter") }}</div>
        <div @click="close" class="common-hover iconfont iconguanbi"></div>
      </div>
      <!-- 搜索项 -->
      <div class="search-item">
        <!-- 时间 -->
        <div class="search-date common-flex">
          <div class="common-flex common-align-center">
            <div class="date-title">{{ $t("order.orderDate") }}</div>
            <DatePicker
              @on-change="changeDate"
              type="daterange"
              :value="[searchItem.startDeliveryDate, searchItem.endDeliveryDate]"
              split-panels
              :placeholder="$t('order.selectDate')"
              style="width: 200px"
            ></DatePicker>
          </div>
        </div>
      </div>

      <div class="common-flex common-justify-center options">
        <div class="back options-btn common-hover" @click="close">
          {{ $t("order.back") }}
        </div>
        <div class="save options-btn common-hover" @click="search">
          {{ $t("order.search") }}
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "r-order-filter",
  data() {
    return {
      show: true,
      searchItem: {
        startDeliveryDate:"",
        endDeliveryDate:""
      },
      // subAccountList: [], //子账号
      // product: [], //品类
      // statusList: [], //状态列表
      // typeList: [], //类型列表
      // sizeList: [], //尺寸
    };
  },
  watch: {
    filteShow: {
      handler(newval, oldval) {
        this.show = newval;
        this.searchItem = this.params;
      },
      immediate: true,
    },
  },
  props: {
    filteShow: Boolean,
    params: Object,
  },
  mounted() {
    // this.findAllSubAccount();
    // this.getClothDictList();
    // this.getType();
    // this.getStatus();
    // this.getSize();
  },
  methods: {
    // ...mapActions([
    //   "findAllSubAccountAction", //获得当前子账号
    //   "getClothDictListAction", //获取去当前品类
    //   "getOrderSearchAction", //搜索项字典
    // ]),
    // 搜索
    search() {
      this.$emit("search", this.searchItem);
    },
    // // 修改状态
    // changeStatus(e) {
    //   this.searchItem.status = e.id;
    // },
    // // 修改尺寸
    // changeSize(e) {
    //   this.searchItem.sizeCategoryId = e.id;
    // },
    // // 修改尺寸
    // changeUser(e) {
    //   this.searchItem.userId = e.id;
    // },
    // // 修改尺寸
    // changeProduct(e) {
    //   this.searchItem.clothId = e.id;
    // },
    // // 修改订单类型
    // changeType(e) {
    //   this.searchItem.orderType = e.id;
    // },
    // 修改时间
    changeDate(e) {
      this.searchItem.startDeliveryDate = e[0];
      this.searchItem.endDeliveryDate = e[1];
    },
    // 关闭弹框
    close() {
      this.$emit("close");
    },
    // // 获得当前子账号
    // findAllSubAccount() {
    //   this.findAllSubAccountAction({ isContainsSelf: true }).then((res) => {
    //     res.data[0].id = "";
    //     this.subAccountList = res.data;
    //   });
    // },
    // 获得品类
    // getClothDictList() {
    //   this.getClothDictListAction({ parentId: 0 }).then((res) => {
    //     res.data.unshift({
    //       name: this.$t("all"),
    //       id: "",
    //     });
    //     this.product = res.data;
    //   });
    // },
    // 获得状态
    // getStatus() {
    //   this.getOrderSearchAction({ category: 9 }).then((res) => {
    //     res.data.unshift({
    //       name: this.$t("all"),
    //       id: "",
    //     });
    //     this.statusList = res.data;
    //   });
    // },
    // 获得类型
    // getType() {
    //   this.getOrderSearchAction({ category: 7 }).then((res) => {
    //     res.data.unshift({
    //       name: this.$t("all"),
    //       id: "",
    //     });
    //     this.typeList = res.data;
    //   });
    // },
    // // 获得尺寸
    // getSize() {
    //   this.getOrderSearchAction({ category: 13 }).then((res) => {
    //     res.data.unshift({
    //       name: this.$t("all"),
    //       id: "",
    //     });
    //     this.sizeList = res.data;
    //   });
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-content {
  border-radius: 0;
}
/deep/.ivu-modal-body {
  padding: 0;
}
.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;
  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}
.options {
  position: relative;
  // width: 1130px;
  margin: 20px auto;
  padding-bottom: 25px;
  .options-btn {
    width: 116px;
    height: 40px;
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    background: #b5bac4;
    margin: 0 7px;
  }
  .save {
    background: #0a4dcc;
  }
}
.search-item {
  width: 1140px;
  margin: 24px auto 60px;
  .search-date {
    border-bottom: 1px solid rgba(8, 25, 56, 0.1);
    > div {
      margin-right: 39px;
      padding-bottom: 18px;
    }
    .date-title {
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #081938;
      margin-right: 11px;
    }
  }
  .search {
    padding: 18px 0 0 0;
    // padding-bottom: 18px;
    border-bottom: 1px dashed rgba(8, 25, 56, 0.1);
    .search-label {
      white-space: nowrap;
      font-size: 14px;
      font-family: Roboto, Roboto-Regular;
      font-weight: 400;
      text-align: left;
      color: #081938;
      line-height: 30px;
      margin-right: 15px;
      min-width: 60px;
    }
    .list {
      .list-item {
        margin-bottom: 24px;
        padding: 0 15px;
        height: 30px;
        line-height: 30px;
      }
      .list-item-choose {
        color: #fff;
        background: #0a4dcc;
        border-radius: 3px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-under-filter.vue